const getUpdatedValue = (changedValue, value) => {
	value = Array.isArray(value) ? value : [];
	const index = value.indexOf(changedValue);
	return index < 0 ? value.concat(changedValue) : value.filter(value => value !== changedValue);
};

const isMatch = (plot, value) => !Array.isArray(value) || value.length === 0 || value.indexOf(plot.status.value) >= 0;

const isSet = (value) => Array.isArray(value) && value.length > 0;

export default {
	getUpdatedValue,
	isMatch,
	isSet
};